import getPlanIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-plan-id'

function isInPlanWorkoutUtil (workout) {
  return !!getPlanIdWorkoutUtil(workout)
}

export default isInPlanWorkoutUtil
